import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../hooks/hooks';
import { selectScheduledTasksConfigurationsQueryItems } from '../../../../../redux/sheduled-tasks-configuration/selector';
import { scheduledTasksConfigurations } from '../../../../../redux/sheduled-tasks-configuration/action';
import PageLoader from '../../../../../components/PageLoader';
import ConfigurationsComponent from '../components/sheduled-task-configuration.component';
import { selectScheduledTasksListItems } from '../../../../../redux/scheduled-tasks/selector';
import { scheduledTasks } from '../../../../../redux/scheduled-tasks/action';
import { selectListItems } from '../../../../../redux/library/selector';
import { accountTypes } from '../../../../../redux/account-types/action';
import { selectAccountsListItems } from '../../../../../redux/accounts/selector';
import { selectAccountTypesListItems } from '../../../../../redux/account-types/selector';
import { accounts } from '../../../../../redux/accounts/action';
import { ListCriteria } from '../../../../types/list-criteria';

const ManagementScheduledTaskConfiguration = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const parmas: any = useParams();
    const configurationsQuery = useSelector(selectScheduledTasksConfigurationsQueryItems);
    const [isQuery, setIsQuery] = useState<boolean>(false);
    const listItems = useSelector(selectScheduledTasksListItems)
    const libraryData = useSelector(selectListItems)
    const [accountTypesList, setAccountTypesList] = useState<any>([]);
    const [associatedAccountTypeId, setAssociatedAccountTypeId] = useState<number | undefined>();
    const [ownerLevelId, setOwnerLevelId] = useState<number | undefined>();
    const accountItems = useSelector(selectAccountsListItems)
    const accountTypeItems = useSelector(selectAccountTypesListItems)
    const [accountsList, setAccountsList] = useState<any>([])
    const [isLoading, setIsLoading] = useState<boolean>(true)
    const TypeData = libraryData?.result?.Type

    const [selectConfigurations, setSelectConfigurations] = useState<any>({});

    const listAccountTypes = async () => {
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBAAccountTypes = async () => {
        // v6.1/organization/dbn/dba-type-dba-mappings
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/dba-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listDBNBizAccountTypes = async () => {
        // v6.1/organization/dbn/biz-net-types
        await dispatch(accountTypes.resetAction({ actionType: 'list' }))
        await dispatch(accountTypes.list({
            url: `https://dbnp.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/organization/dbn/biz-net-types/list`,
            entity: 'accountTypes',
            jsonData: {}
        }))
    }

    const listAccountsByType = async ({ searchCriteria, filterCriteria, dateCriteria }: ListCriteria) => {
        await dispatch(accounts.resetAction({ actionType: 'list' }))
        await dispatch(accounts.list({
            url: `https://identity.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/organization/rms/accounts/list`,
            entity: 'accounts',
            jsonData: {
                "Filters": filterCriteria,
                "Searches": searchCriteria,
                "DateCriteria": dateCriteria,
            }
        }))
    }

    const fetchLMSChaptersQueryById = () => {
        dispatch(scheduledTasksConfigurations.query({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/schedule-task-configurations/query`,
            entity: 'scheduledTasksConfigurations',
            jsonData: {
                Context: {},
                Records: [
                    {
                        Id: parmas?.id
                    }
                ]
            }
        })).then(() => {
            setIsQuery(true);
        });
    }

    const handleInnerFormChange: any = (event: any, field: string) => {
        setSelectConfigurations({ ...selectConfigurations, [field]: event })
    }




    useEffect(() => {
        dispatch(scheduledTasks.list({
            url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/platform-scheduled-tasks/list`,
            entity: 'scheduledTasks',
            jsonData: {}
        }))
            .then(() => {
                dispatch(accountTypes.list({
                    url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/rms/account-types/list`,
                    entity: 'accountTypes',
                    jsonData: {}
                }))
            })
            .then(() => {
                if (parmas?.id > 0) {
                    fetchLMSChaptersQueryById()
                }
            })
    }, [])


    useEffect(() => {
        if (isQuery && configurationsQuery?.result?.items?.length > 0) {
            const queryData: any = configurationsQuery?.result?.items?.[0];

            const mappedConfig = {
                Id: queryData?.Id,
                Name: queryData?.Name,
                Enabled: queryData?.Enabled,
                OwnerType: queryData?.OwnerType || "",
                OwnerLevelId: queryData?.OwnerLevelId || 0,
                OwnerTypeId: queryData?.OwnerTypeId || 0,
                OwnerAccountId: queryData?.OwnerAccountId || 0,
                OwnerLevel: queryData?.OwnerLevel || "",
                OwnerAccountName: queryData?.OwnerAccountName || "",
                Command: queryData?.ScheduleCommands[0]?.Command,
                Instruction: queryData?.ScheduleCommands[0]?.Instruction,
                DisplayOrder: queryData?.ScheduleCommands[0]?.DisplayOrder,
                ScheduleCommandTypeId: queryData?.ScheduleCommands[0]?.ScheduleCommandTypeId,

            };

            setSelectConfigurations(mappedConfig);
        }
    }, [isQuery, configurationsQuery]);



    useEffect(() => {
        setAssociatedAccountTypeId(selectConfigurations?.OwnerTypeId);
        setOwnerLevelId(selectConfigurations?.OwnerLevelId);
    }, [selectConfigurations]);

    useEffect(() => {
        if (associatedAccountTypeId && accountTypesList) {
            const accountTypeName = accountTypesList?.find(
                (item: any) => item.Id === associatedAccountTypeId
            )?.Name;
            const accountTypeValue = TypeData.find(
                (type: any) => type.Text === accountTypeName
            )?.Text;
            if (accountTypeValue) {
                listAccountsByType({
                    filterCriteria: [{
                        "FieldName": "Type",
                        "FilterOperatorId": 6,
                        "FieldValue": accountTypeValue,
                        "FieldType": "text"
                    }]
                })
            }
        }
    }, [accountTypesList, associatedAccountTypeId]);



    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                listAccountTypes();
                break;
            case 11:
                listDBAAccountTypes();
                break;
            case 12:
                listDBNBizAccountTypes();
                break;
            default:
                dispatch(accountTypes.resetAction({ actionType: 'list' }))
                break;

        }
    }, [ownerLevelId]);

    useEffect(() => {
        switch (ownerLevelId) {
            case 10:
                setAccountTypesList(accountTypeItems?.result?.items);
                setAccountsList([]);
                break;
            case 11:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.Id, Name: o?.Name } }));
                setAccountsList([]);
                break;
            case 12:
                setAccountTypesList(accountTypeItems?.result?.items?.map(o => { return { Id: o?.IEAccountTypeId, Name: o?.IEAccountTypeName } }));
                setAccountsList([]);
                break;
            default:
                setAccountTypesList([]);
                setAccountsList([]);
                break;

        }
    }, [accountTypeItems]);

    useEffect(() => {
        dispatch(accounts.resetAction({ actionType: 'list' }))
        setAccountsList([])
    }, []);

    useEffect(() => {
        setAccountsList(accountItems?.result?.items || [])
    }, [accountItems]);


    const handleFormSubmit = async (event: any) => {
        event.preventDefault();

        const rateData = {
            "Id": selectConfigurations?.Id || 0,
            "Command": selectConfigurations?.Command,
            "DisplayOrder": selectConfigurations?.DisplayOrder,
            "Enabled": selectConfigurations?.Enabled,
            "Instruction": selectConfigurations?.Instruction,
            "OwnerAccountId": selectConfigurations?.OwnerAccountId,
            "Name": selectConfigurations?.Name,
            "OwnerLevelId": selectConfigurations?.OwnerLevelId,
            "OwnerTypeId": selectConfigurations?.OwnerTypeId,
            "ScheduleCommandTypeId": selectConfigurations?.ScheduleCommandTypeId,

            "ScheduleCommands": [{
                "Command": selectConfigurations?.Command,
                "DisplayOrder": selectConfigurations?.DisplayOrder,
                "Instruction": selectConfigurations?.Instruction,
                "ScheduleCommandTypeId": selectConfigurations?.ScheduleCommandTypeId,

            }]
        }
        if (parmas?.id > 0) {
            await dispatch(scheduledTasksConfigurations.resetAction({ actionType: 'update' }))
            await dispatch(scheduledTasksConfigurations.update({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/schedule-task-configurations`,
                entity: 'scheduledTasksConfigurations',
                jsonData: {
                    Records: [
                        rateData
                    ]
                }
            })).then(() => {
                back();
            });
        } else {
            await dispatch(scheduledTasksConfigurations.resetAction({ actionType: 'create' }))
            await dispatch(scheduledTasksConfigurations.create({
                url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v6.1/system/schedule-task-configurations`,
                entity: 'scheduledTasksConfigurations',
                jsonData: {
                    Records: [
                        rateData
                    ]
                }
            })).then(() => {
                back();
            });
        }
    }

    const back = () => {
        navigate('/management/system/scheduled-tasks-configuration');
    }

    return (
        <>
            {configurationsQuery?.isLoading ? <PageLoader /> :
                <ConfigurationsComponent
                    handleInnerFormChange={handleInnerFormChange}
                    selectConfigurations={selectConfigurations}
                    platForms={listItems?.result?.items}
                    sheduledType={libraryData?.result?.ScheduleCommandType}
                    PolicyOwnerType={libraryData?.result?.PolicyOwnerType}
                    back={back}
                    handleFormSubmit={handleFormSubmit}
                    accountTypesListLoading={accountTypeItems?.isLoading}
                    accountTypesList={accountTypesList}
                    accountListLoading={accountItems?.isLoading}
                    accountsList={accountsList}
                    isLoading={isLoading}
                />
            }
        </>
    );
}

export default ManagementScheduledTaskConfiguration;
